import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import resolveDeviceName from "src/modules/device/resolveDeviceName";
import retrieveXmppCredentials from "../retrieveXmppCredentials";

const initialState = {
  user: null,
  lastSyncDate: new Date(),
  device: {
    xmppCredentials: retrieveXmppCredentials(),
    name: resolveDeviceName(),
    originalName: null,
    color: null
  }
};

const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    logInSuccess(state, { payload }) {
      state.user = payload;
    },
    signOutRequest(state, { payload }) {
      state.user = payload;
    },
    signOutSuccess() {
      return;
    },
    updateUserSuccess(state, { payload }) {
      state.user = { ...state.user, ...payload };
      state.lastSyncDate = new Date();
    },
    synchronizeUserSuccess(state, { payload }) {
      state.user = payload;
      state.lastSyncDate = new Date();
    },
    anonymousSignInSuccess(state, { payload }) {
      state.device.xmppCredentials = payload.xmppCredentials;
      state.user = payload.user;
    },
    updateDevice(state, { payload }) {
      state.device = { ...state.device, ...payload };
    }
  }
});

export { authSlice };

export default {
  createReducer: (storage) => {
    const persistConfig = {
      key: "auth",
      whitelist: ["user", "lastSyncDate"],
      storage
    };
    return persistReducer(persistConfig, authSlice.reducer);
  }
};
